import React from 'react';
import PropTypes from 'prop-types';

import OverlayModal from 'dpl/components/OverlayModal';
import BuyerApplicationLayout from 'dpl/new_buyer_application/components/BuyerApplicationLayout';
import { FEATURES } from 'dpl/shared/constants/features';
import isFeatureEnabled from 'dpl/util/isFeatureEnabled';

import ApplicationEntryContainer from '../containers/ApplicationEntryContainer';

const BUYER_APPLICATION_QUIZ_ON =
  isFeatureEnabled(FEATURES.BUYER_APPLICATION_QUIZ) &&
  // HACK so we don't have to keep turning flag on and off in staging
  window.location.search.includes('buyer_application_quiz');

// TODO: move this to new_buyer_application domain after migration
export default function Overlay({ onClose }) {
  return (
    <OverlayModal hideCloseButton onClose={onClose}>
      {BUYER_APPLICATION_QUIZ_ON ? (
        <BuyerApplicationLayout />
      ) : (
        <ApplicationEntryContainer onCloseClick={onClose} />
      )}
    </OverlayModal>
  );
}

Overlay.propTypes = {
  onClose: PropTypes.func.isRequired
};
